import { api } from './api.service';
import { authStore } from './auth.service';
import { getConfig } from '../lib/runtime-config';

export interface MfaInitiateResponse {
  method: string;
  secretBase32: string;
  otpauthUrl: string;
  issuer: string;
  username: string;
  algorithm: string;
  digits: number;
  period: number;
}

/**
 * Starts the TOTP MFA setup for the currently logged-in user. Returns the
 * shared secret + otpauth URL that has to be encoded as a QR code.
 */
export async function initiateMfaSetup(): Promise<MfaInitiateResponse> {
  const token = authStore.getToken();
  const user = authStore.getUser();
  if (!token || !user) {
    throw new Error('not authenticated');
  }

  const cfg = getConfig();
  const path = `/api/module/ums/${token}/user/${user.userId}/mfa/setup/initiate`;
  return api<MfaInitiateResponse>(path, {
    method: 'POST',
    body: { type: 'totp', issuer: cfg.mfa.issuer }
  });
}

/**
 * Verifies the user-provided TOTP code, activates MFA on success and updates
 * the local session payload so the auth-guard releases the user.
 */
export async function verifyMfaSetup(code: string): Promise<void> {
  const token = authStore.getToken();
  const user = authStore.getUser();
  if (!token || !user) {
    throw new Error('not authenticated');
  }

  const path = `/api/module/ums/${token}/user/${user.userId}/mfa/setup/verify`;
  await api<{success: boolean}>(path, {
    method: 'POST',
    body: { code }
  });

  authStore.patchUser({ mfaEnabled: true });
}
